import {
  put, all, select, call, takeLatest, fork,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { exception } from 'circe/logger';
import { show as showNotification } from 'circe/notifications/actions';
import moment from 'moment';
import * as I18n from 'circe/I18n';
import * as listingSaga from 'circe/listing/saga';
import {
  fetch, fetched, fetchNext, fetchPrev, fetching, cache,
} from './actions';
import {
  getHasNext,
  getHasPrev,
  getNextCursor,
  getPrevCursor,
  getFromCache,
  getFilters,
} from './selectors';
import * as api from './api';

function* doFetch(action) {
  try {
    const { payload } = action;

    const { filters } = payload;

    const { start, end, ...restFilters } = filters;

    const allFilters = {
      ...restFilters,
      start: start
        ? moment(start)
          .startOf('day')
          .valueOf()
        : undefined,
      end: start
        ? moment(end)
          .endOf('day')
          .valueOf()
        : undefined,
      did: SYSTEM_DOMAIN,
    };

    yield fork(listingSaga.doFetch, {
      api: api.fetch,
      filters: allFilters,
      fetched,
      cache,
      getFromCache,
      getCurrentAuthHeader,
    });
  } catch (e) {
    yield put(
      showNotification(
        I18n.str('transactionsFetchFailed', 'Unable to fetch transactions.'),
        'error',
      ),
    );
    exception(e);
  }
}

export function* doFetchNext(context) {
  yield fork(listingSaga.doFetchNext, {
    fetching,
    getHasNext,
    getNextCursor,
    getFilters,
    doFetch,
  });
}

export function* doFetchPrev() {
  yield fork(listingSaga.doFetchPrev, {
    fetching, // action
    getHasPrev, // selector
    getPrevCursor, // selector
    getFilters, // filters
    doFetch, // geneatr
  });
}

function* watcher(context) {
  yield all([
    takeLatest(fetch().type, doFetch),
    takeLatest(fetchNext().type, doFetchNext),
    takeLatest(fetchPrev().type, doFetchPrev),
  ]);
}

export default watcher;
